import React from 'react';
import Select from 'react-select';
import variaveis from '../../styles/variaveis.css';

const customStyle = {
	control: (styles, { isFocused }) => ({
		...styles,
		backgroundColor: 'white',
		borderColor: isFocused ? variaveis.selectHover : variaveis.gray300,
		boxShadow: variaveis.selectHover,
		'&:hover': {
			borderColor: variaveis.selectHover,
		},
		maxHeight: '150px',
		overflowY: 'auto',
	}),
	option: (styles, { isFocused, isSelected }) => ({
		...styles,
		backgroundColor: (isSelected || isFocused) ? variaveis.selectHover : 'white',
		color: (isFocused || isSelected) ? 'white' : 'default',
		':active': {
			backgroundColor: variaveis.selectHover,
		},
	}),
};

const SelectMulti = ({
	name,
	onChange,
	value,
	options,
	uniqueKey = 'id',
	label,
	isMulti,
	isClearable,
	placeholder,
	isDisabled,
}) => {
	const formatedArray = options.map((originalValue) => {
		const formatedValue = {
			value: originalValue[uniqueKey],
			label: originalValue[label],
			object: originalValue,
		};
		if (value && originalValue[uniqueKey] === value[uniqueKey]) {
			value = formatedValue;
		}
		return formatedValue;
	});

	return (
		<Select
			isDisabled={isDisabled}
			name={name}
			value={value}
			noOptionsMessage={() => 'Lista vazia'}
			isClearable={isClearable}
			isMulti={isMulti}
			placeholder={placeholder || 'Selecione...'}
			onChange={onChange}
			options={formatedArray}
			styles={customStyle}
		/>
	);
};

export default SelectMulti;
